import { registerNotification } from "@/shared/api/websocket"
import { captureError } from "@/shared/lib/diagnostics"
import { revalidateUser } from "../auth/revalidate-user"

registerNotification("permissions_changed", {
	handle: (_notification, ctx) => {
		revalidateUser(ctx.queryClient).catch((error: unknown) => {
			captureError(error, { scope: "permissionsChanged.revalidate" })
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
